import { ActionType, createSelector } from '@ngxs/store';

import { API_STATE_TOKEN, ApiMutatorStateModel, ApiStateModel } from './api-state.models';
import { ApiStoreFilterValues, ApiStoreSettings } from '@app/core/store/models/api-store.models';

export function createApiMetadataSelector<T extends keyof ApiMutatorStateModel>(
  action: ActionType,
  property: T,
  defaultValue?: ApiMutatorStateModel[T],
) {
  return createSelector(
    [API_STATE_TOKEN],
    ({ metadata }: ApiStateModel): ApiMutatorStateModel[T] => metadata[action.type]?.[property] ?? defaultValue,
  );
}

export function getGlobalFilters<T extends object>(
  values: ApiStoreFilterValues<T>,
  options: ApiStoreSettings<T>,
  init?: ApiStoreFilterValues<T>,
): ApiStoreFilterValues<T> {
  values = options?.globalFilterMutator ? options.globalFilterMutator(values) : { ...values };

  if (init?.filterValues) {
    values.filterValues = {
      ...init.filterValues,
      ...values.filterValues,
    };
  }
  if (init?.searchValues) {
    values.searchValues = {
      ...init.searchValues,
      ...values.searchValues,
    };
  }

  return values;
}
